import React from 'react';

const SelectInput = ({ 
  label, name, register, errors, options, validationRules = {}, defaultValue='', helpText, className='', fullWidth=true, ...rest 
}) => (
  <div className={`mb-2 ${fullWidth ? 'w-full' : ''} ${className}`} {...rest}>
    <label className='label label-text' htmlFor={name}>{label}</label>
    <select
      id={name}
      defaultValue={defaultValue}
      className={`select select-bordered ${fullWidth ? 'w-full' : ''}`} 
      {...register(name, validationRules)}
    >
      <option disabled value="">Select {label}</option>
      {options.map((option, index) => (
        <option key={index} value={option.value} >
          {option.label}
        </option>
      ))}
    </select>
    {errors[name] && <p className='text-sm text-red-400'>{errors[name].message}</p>}
    {helpText && (
      <p className="text-xs text-gray-500 mt-1">
        {helpText}
      </p>
    )}
  </div>
);

export default SelectInput;
